import { BaseControl } from "../base-control";

class MultiselectControlCtrl extends BaseControl {
  requiredValid = false;

  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
    this.showList = false;
    this.valueArray = [];
    this.originalValue = null;
  }

  async $onInit(){
    await super.$onInit();
    // QB returns object with {_, BR} properties in some cases. Why?
    this.displayValue = this.model?.display?._ || this.model?.display || '';
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
  }

  updateFlags() {
    this.setValueArray();
    this.requiredValid =  this.model.value || !this.required;
  }
  
  setValueArray(){
    this.valueArray = this.model.value ? this.model.value.toString().split(this.token.control.delimiter) : [];
  }
  
  toggleMultiselect(optn) {
    this.valueArray.includes(optn)
      ? this.stdModel(this.valueArray.filter(e => e !== optn))
      : this.stdModel([...this.valueArray, optn]);
  }

  toggleList() {
    if (!this.enabled) return;
    this.showList = !this.showList;
    if (this.showList) {
      this.originalValue = this.model.value;
    }
    const selector = this.showList ? `${this.token.id}-mslist` : `${this.token.id}-control`;
    this.$timeout(_ => document.getElementById(selector)
      .scrollIntoView({behavior: 'auto', block: 'center', inline: 'center' }));
  }

  cancelList() {
    if (!this.enabled || !this.showList) return;
    // Assign directly: arrayToString setter would clear a string snapshot
    this.model.value = this.originalValue;
    this.model.display = null;
    this.updateFlags();
    this.toggleList();
  }

  updateBehaviorsStatus() {
    super.updateBehaviorsStatus();
    this.updateFlags();
  }

}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/multiselect-control/multiselect-control.component.html",
  controller: MultiselectControlCtrl
};